import { Pipe, PipeTransform } from '@angular/core';
import { applyMask } from './mask.utils';

/**
 * Pipe de máscara para exibição.
 * Uso: {{ valor | mask:'0000 0000 0000 0000' }}
 */
@Pipe({ name: 'mask' })
export class MaskPipe implements PipeTransform {
  transform(value: string | null | undefined, pattern: string): string {
    if (pattern == null || pattern === '') return value ?? '';
    return applyMask(value, pattern);
  }
}
